class SplitCursor extends HTMLElement {
  connectedCallback() {
    this.section = this.closest(".before-after");
    this.before = this.section.querySelector(".before-after__after");
    this.dragging = false;

    this.addEventListener("pointerdown", this.startDrag.bind(this));
    window.addEventListener("pointerup", this.stopDrag.bind(this));
    window.addEventListener("pointermove", this.drag.bind(this));
  }

  startDrag(e) {
    e.preventDefault(); // ✅ only block selection when dragging the handle
    this.dragging = true;
    this.section.classList.add("dragging");
  }

  stopDrag() {
    this.dragging = false;
    this.section.classList.remove("dragging");

    this.before.style.willChange = 'auto';
    this.before.offsetHeight; // force reflow
  }

  drag(e) {
    if (!this.dragging) return;

    const rect = this.section.getBoundingClientRect();
    const offset = e.clientX - rect.left;

    // Clamp fully from 0 to width
    const clamped = Math.floor(Math.max(0, Math.min(offset, rect.width)));
    this.before.style.clipPath = `inset(0 0 0 ${clamped}px)`;
    this.style.left = `${clamped}px`;
    this.style.setProperty("--clip-path-offset", `${clamped}px`);
  }
}

customElements.define("split-cursor", SplitCursor);
